import React from "react";
import { CHECKOUT_URL } from "../lib/constants";
import { trackPixel } from "../lib/useMetaPixel";
type CtaButtonProps = {
  children: React.ReactNode;
  className?: string;
  pulse?: boolean;
};
export function CtaButton({
  children,
  className = "",
  pulse = true
}: CtaButtonProps) {
  return <a href={CHECKOUT_URL} onClick={() => trackPixel("InitiateCheckout")} className={`inline-flex w-full items-center justify-center rounded-full bg-[#a04a63] px-6 py-4 text-center text-base font-extrabold uppercase tracking-wide text-white shadow-lg transition-colors hover:bg-[#8a3a52] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#c98aa0] sm:text-lg ${pulse ? "animate-cta-pulse" : ""} ${className}`} data-id="element-47" data-mp="ckj71hbwq9lp">
      {children}
    </a>;
}